module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/vm.92340eca.svg";